const CS_SCROLL_BREAKPOINT = 992;

const csInternalScrollReset = (track, boxes, gradient) => {
    if (track) {
        track.style.height = '';
        track.style.overflow = '';
        track.style.position = '';
        track.style.top = '';
    }
    if (boxes) {
        gsap && gsap.set(boxes, { clearProps: 'y' });
    }
    if (gradient) {
        gradient.style.opacity = '';
        gradient.classList.remove('is-hidden');
    }
};

const csInternalScrollInit = (block) => {
    const sections = block
        ? [block[0].querySelector('.bn-cs-scroll')]
        : Array.from(document.querySelectorAll('.bn-cs-scroll'));

    if (!sections || !sections.length) return;

    sections.forEach((section) => {
        const gradient = section.closest('.bn-cs-scroll__gradient');
        const track = section.querySelector('.bn-cs-scroll__track');
        const boxes = section.querySelector('.bn-cs-scroll__boxes');
        const image = section.querySelector('.bn-cs-scroll__image');

        if (!track || !boxes) {
            if (section) section.style.opacity = '1';
            return;
        }

        if (window.innerWidth <= CS_SCROLL_BREAKPOINT) {
            csInternalScrollReset(track, boxes, gradient);
            section.style.opacity = '1';
            return;
        }

        const boxElements = boxes.querySelectorAll('.bn-cs-scroll__box');
        if (boxElements.length < 2) {
            if (gradient) gradient.style.opacity = '0';
            section.style.opacity = '1';
            return;
        }

        const peekHeight = 200;
        const gap = 20;

        const firstBox = boxElements[0];
        const firstBoxHeight = firstBox.offsetHeight;
        const visibleHeight = firstBoxHeight + gap + peekHeight;

        const totalScroll = boxes.scrollHeight - visibleHeight;

        if (totalScroll <= 0) {
            if (gradient) gradient.style.opacity = '0';
            section.style.opacity = '1';
            return;
        }

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        section.style.height = `${visibleHeight + totalScroll + 100}px`;

        track.style.height = visibleHeight + 'px';
        track.style.overflow = 'hidden';
        track.style.position = 'sticky';
        track.style.top = '100px';

        if (image) {
            image.style.position = 'sticky';
            image.style.top = '100px';
            image.style.alignSelf = 'flex-start';
        }

        gsap.registerPlugin(ScrollTrigger);

        if (gradient) {
            ScrollTrigger.create({
                trigger: section,
                start: 'top 40%',
                end: 'bottom top',
                onEnter: () => gradient.classList.add('is-active'),
                onLeaveBack: () => gradient.classList.remove('is-active'),
                onLeave: () => gradient.classList.remove('is-active'),
                onEnterBack: () => gradient.classList.add('is-active'),
            });
        }

        gsap.to(boxes, {
            y: -totalScroll,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 1,
                onEnter: () => section.classList.add('is-scrolling'),
                onLeave: () => section.classList.add('is-done'),
                onEnterBack: () => section.classList.remove('is-done'),
                onUpdate: (self) => {
                    if (!gradient) return;
                    if (self.progress > 0.95) {
                        gradient.classList.add('is-hidden');
                    } else {
                        gradient.classList.remove('is-hidden');
                    }
                },
            },
        });

        section.style.opacity = '1';
    });

    if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
    }
};

const csScrollRefreshOnConsentChange = () => {
    const waitFor = (check, cb, max = 50) => {
        if (check()) { cb(); return; }
        let i = 0;
        const t = setInterval(() => {
            if (check()) { clearInterval(t); cb(); }
            if (++i >= max) clearInterval(t);
        }, 200);
    };

    const reinit = () => {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll()
                .filter(t => t.vars.trigger instanceof Element && t.vars.trigger.closest('.bn-cs-scroll'))
                .forEach(t => t.kill());
        }

        document.querySelectorAll('.bn-cs-scroll').forEach(section => {
            section.classList.remove('is-scrolling', 'is-done');
            section.style.cssText = '';
            section.style.opacity = '0';
            const track = section.querySelector('.bn-cs-scroll__track');
            const boxes = section.querySelector('.bn-cs-scroll__boxes');
            const gradient = section.closest('.bn-cs-scroll__gradient');
            csInternalScrollReset(track, boxes, gradient);
        });

        csInternalScrollInit();
    };

    document.addEventListener('cookieyes-consent-update', () => {
        waitFor(() => typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined', reinit);
    }, { once: true });
};

document.addEventListener('DOMContentLoaded', function () {
    if (
        !document.body.classList.contains('block-editor-page') &&
        !document.body.classList.contains('block-editor-iframe__body')
    ) {
        document.querySelectorAll('.bn-cs-scroll').forEach(el => {
            el.style.opacity = '0';
            el.style.transition = 'opacity 0.3s ease-in-out';
        });

        window.addEventListener('load', () => {
            const poll = setInterval(() => {
                if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                    clearInterval(poll);
                    csInternalScrollInit();
                }
            }, 100);

            setTimeout(() => {
                clearInterval(poll);
                document.querySelectorAll('.bn-cs-scroll').forEach(el => {
                    if (el.style.opacity === '0') el.style.opacity = '1';
                });
            }, 10000);
        });

        csScrollRefreshOnConsentChange();
    } else if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=bn/case-study-internal-scroll',
            (block) => {
                const els = block && block[0] ? block[0].querySelectorAll('.bn-cs-scroll') : [];
                els.forEach(el => {
                    el.style.opacity = '0';
                    el.style.transition = 'opacity 0.3s ease-in-out';
                });
                setTimeout(() => csInternalScrollInit(block), 300);
            }
        );
    }
});